export const getCriteria = `
  query getCriteriaGroup($criteriaGroupIds: [Int!]!) {
    criteriaGroup(criteriaGroupIds: $criteriaGroupIds) {
      id
      operator
      criteriaLevels {
        id
        operator
        criterias {
          id
          parentId
          criteriaType
          operator
          conditionComparator
          conditionKey
          conditionValue
          subConditionKey
          subConditionComparator
          subConditionValue
          conditionTimeFilter {
            id
            filterName
            fromTime
            toTime
            offsetValue
            calculatedFromTime
            calculatedToTime
          }
          subConditionTimeFilter {
            id
            filterName
            fromTime
            toTime
            offsetValue
            calculatedFromTime
            calculatedToTime
          }
          timeFilter {
            id
            filterName
            fromTime
            toTime
            offsetValue
            calculatedFromTime
            calculatedToTime
          }
        }
      }
    }
  }
`;
